/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;
const { tabsBoxShadow } = boxShadows;

export default {
  styleOverrides: {
    root: ({ theme }) => ({
      position: "relative",
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,0.06)"
          : theme.palette.grey?.[100] || "#f8f9fa",
      border: theme.palette.mode === "dark" ? "1px solid rgba(255,255,255,0.1)" : "none",
      borderRadius: borderRadius.lg,
      minHeight: "unset",
      padding: pxToRem(4),
    }),

    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 10,
    },

    fixed: {
      overflow: "unset !important",
      overflowX: "unset !important",
    },

    vertical: {
      "& .MuiTabs-indicator": {
        width: "100%",
      },
    },

    indicator: ({ theme }) => ({
      height: "100%",
      borderRadius: borderRadius.md,
      backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.12)" : "#ffffff",
      boxShadow:
        theme.palette.mode === "dark"
          ? "0 1px 5px 1px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(255,255,255,0.1)"
          : tabsBoxShadow.indicator,
      transition: "all 500ms ease",
    }),
  },
};
